import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";

export function PracticeCard({ area, index }) {
  return (
    <Reveal delay={index * 0.12}>
      <article
        data-testid={area.testId}
        className="group relative flex h-full flex-col border border-border bg-card transition-all duration-500 hover:border-gold/50 hover:shadow-[0_24px_60px_-24px_hsl(var(--gold)/0.25)]"
      >
        <div className="relative h-56 overflow-hidden">
          <img
            src={area.image}
            alt={area.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent" />
          <span className="absolute left-5 top-5 border border-background/30 bg-background/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-foreground backdrop-blur-md">
            {area.num}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-7">
          <h3 className="font-serif text-2xl font-medium tracking-tight">{area.title}</h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{area.tagline}</p>
          <Link
            to={`/services/${area.id}`}
            data-testid="service-modal-trigger"
            className="mt-6 inline-flex items-center gap-2 self-start font-mono text-xs uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:text-foreground"
          >
            Explore
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </article>
    </Reveal>
  );
}
